import { getModuleRowId, getModuleRowValue } from './api/moduleRowFields';
import { resolveAiChatModuleKey } from './resolveAiChatModuleKey';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Resolves the project module row GUID for chatbot config APIs.
 *
 * @param {string} pathname
 * @param {string} [search]
 * @param {Array<object>|undefined|null} customizedModules — Redux `projects.customizedModules`
 * @returns {string | null}
 */
export function resolveChatbotModuleId(pathname, search, customizedModules) {
  const key = resolveAiChatModuleKey(pathname, search);
  if (key == null || key === '') {
    return null;
  }
  const keyStr = String(key).trim();
  if (UUID_RE.test(keyStr)) {
    return keyStr;
  }
  const modules = Array.isArray(customizedModules) ? customizedModules : [];
  const kl = keyStr.toLowerCase();
  const row = modules.find((m) => {
    const v = getModuleRowValue(m);
    return v != null && String(v).trim().toLowerCase() === kl;
  });
  if (!row) {
    return null;
  }
  const id = getModuleRowId(row);
  return id != null && id !== '' ? String(id) : null;
}
